/* eslint-disable no-undef */
import i18n from '@/i18n';
import moment from 'moment';
import { formatDateCommon, tranferShortCode } from '@/utils/format';
import store from '@/state/store';

const configs = {
    configSelectCampaign: {
        trackBy: 'id',
        label: 'name',
        error: false,
        errorField: '',
        errorMsg: 'キャンペーン名を選択してください。',
        isRemove: false,
        loading: false
    },
    configFieldSelectClient: {
        trackBy: 'client_id',
        label: 'client_name',
        error: false,
        errorField: 'エンドクライアント',
        isRemove: true,
        valueSync: '',
        typesValidate: ['requiredSelect']
    },
    configExportSchedule: {
        id: '',
        code: '',
        class: 'modal-custom-tab-basic-cp',
        title: i18n.t('sheduleFile.popUpSchedule'),
        model: false,
        scrollable: true,
        hideFooter: false,
        size: 'xl',
        validate: true,
        dataCPType: [],
        dataDocument: [],
        listIDWorks: []
    },
    configModalCommonCondition: {
        id: '',
        title: '条件設定',
        model: false,
        scrollable: true,
        hideFooter: false,
        size: 'md',
        class: 'h-50',
        typeDoc: '',
        validate: true
    },
    configModalCommonConditionFMT: {
        id: '',
        title: i18n.t('document.mumberOfMessagesFMT'),
        model: false,
        scrollable: true,
        hideFooter: false,
        size: 'lg',
        class: 'h-80',
        detailBeginForDocument: null,
        validate: true
    },
    configModalConditionContactFMT: {
        id: '',
        title: i18n.t('document.contactFMT'),
        model: false,
        scrollable: true,
        hideFooter: false,
        size: 'lg',
        class: 'h-80',
        detailBeginForDocument: null,
        validate: true
    },
    configModalCommonPreview: {
        id: '',
        title: '内容',
        model: false,
        scrollable: true,
        hideFooter: false,
        size: 'xl',
        titleBtnSave: '閉じる'
    },
    configModalCommonConditionOther: {
        id: '',
        title: '内容',
        model: false,
        scrollable: true,
        hideFooter: false,
        class: 'h-100',
        size: '4xl',
        validate: true
    },
    configFaq: {
        isLoadingPreviewFAQ: false,
        listData: {},
        listTitle: {},
        id: '',
        title: 'プレビュー',
        model: false,
        scrollable: true,
        hideFooter: false,
        size: '4xl',
        class: 'modal-custom-tab-basic-cp faq-modal-doc',
        titleBtnCancel: i18n.t('btn.backList')
    },
    configFieldCycle: {
        trackBy: 'id',
        label: 'name',
        error: false,
        isRemove: true,
        errorField: i18n.t('document.deliveryCycle'),
        valueSync: null,
        isRequired: false,
        typesValidate: ['requiredSelect']
    },
    configFieldClosingDate: {
        trackBy: 'id',
        label: 'name',
        error: false,
        isRemove: true,
        errorField: i18n.t('document.closingDate'),
        valueSync: null,
        isRequired: false,
        typesValidate: ['requiredSelect']
    },
    configFieldReportDate: {
        trackBy: 'id',
        label: 'name',
        error: false,
        isRemove: false,
        errorField: i18n.t('document.reportDate'),
        valueSync: null,
        isRequired: false,
        typesValidate: ['requiredSelect']
    }
};

const cycleFMT = [
    {
        id: 1,
        name: '週報'
    },
    {
        id: 2,
        name: '月報'
    },
    {
        id: 3,
        name: '最終一括'
    }
];
const DayOfWeek = [
    {
        id: 1,
        name: '月曜日'
    },
    {
        id: 2,
        name: '火曜日'
    },
    {
        id: 3,
        name: '水曜日'
    },
    {
        id: 4,
        name: '木曜日'
    },
    {
        id: 5,
        name: '金曜日'
    },
    {
        id: 6,
        name: '土曜日'
    },
    {
        id: 7,
        name: '日曜日'
    }
];

const REPORT_DATE = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15];

function findDeliveryCycle(deliveryCycle) {
    return cycleFMT.find((item) => item.id === deliveryCycle) || cycleFMT[0];
}

function replaceQ(data, detailBeginForDocument) {
    const qc = detailBeginForDocument;
    const shortCodeMap = {
        キャンペーン名: qc?.name,
        グループの合計: qc?.group_total,
        グループの対象商品含む: qc?.include_group_target_product,
        グループの対象商品: qc?.group_target_product,
        公式Instagramアカウント名: qc?.instagram_name,
        キャンペーンサイトURL: qc?.url,
        CP指定ハッシュタグ: qc?.hashtag_formatted,
        応募種別: qc?.categories_formatted,
        クライアント名: qc?.clients_formatted,
        キャンペーン事務局TEL: qc?.tel,
        キャンペーン事務局Mailアドレス: qc?.email,
        キャンペーン開始: qc?.campaign_start_date ? moment(qc.campaign_start_date).locale('ja').format('YYYY年MM月DD日（ddd）') : null,
        キャンペーン終了: qc?.campaign_end_date ? moment(qc.campaign_end_date).locale('ja').format('YYYY年MM月DD日（ddd）') : null,
        事務局開始: qc?.secretariat_start_date ? formatDateCommon(qc.secretariat_start_date, 'dateTimeJP') : null,
        事務局終了: qc?.secretariat_end_date ? formatDateCommon(qc.secretariat_end_date, 'dateTimeJP') : null,
        年末年始休み:
            qc?.year_end_schedule_from || qc?.year_end_schedule_to
                ? `(${moment(qc.year_end_schedule_from).locale('ja').format('YYYY年MM月DD日（ddd）')} ~ ${moment(qc.year_end_schedule_to)
                      .locale('ja')
                      .format('YYYY年MM月DD日（ddd）')})`
                : qc?.year_end_schedule_formatted ?? null,
        ...cloneMapShortCodeFaq(qc)
    };
    let result = data;
    result = tranferShortCode(result, shortCodeMap);
    return result;
}

function replaceA(array, detailBeginForDocument) {
    const ac = detailBeginForDocument;
    const shortCodeAMap = {
        キャンペーン名: ac?.name,
        グループの合計: ac?.group_total,
        グループの対象商品含む: ac?.include_group_target_product,
        グループの対象商品: ac?.group_target_product,
        公式Instagramアカウント名: ac?.instagram_name,
        キャンペーンサイトURL: ac?.url,
        CP指定ハッシュタグ: ac?.hashtag_formatted,
        応募種別: ac?.categories_formatted,
        クライアント名: ac?.clients_formatted,
        キャンペーン事務局TEL: ac?.tel,
        キャンペーン事務局Mailアドレス: ac?.email,
        キャンペーン開始: ac?.campaign_start_date ? moment(ac.campaign_start_date).locale('ja').format('YYYY年MM月DD日（ddd）') : null,
        キャンペーン終了: ac?.campaign_end_date ? moment(ac.campaign_end_date).locale('ja').format('YYYY年MM月DD日（ddd）') : null,
        事務局開始: ac?.secretariat_start_date ? formatDateCommon(ac.secretariat_start_date, 'dateTimeJP') : null,
        事務局終了: ac?.secretariat_end_date ? formatDateCommon(ac.secretariat_end_date, 'dateTimeJP') : null,
        年末年始休み:
            ac?.year_end_schedule_from || ac?.year_end_schedule_to
                ? `(${moment(ac.year_end_schedule_from).locale('ja').format('YYYY年MM月DD日（ddd）')} ~ ${moment(ac.year_end_schedule_to)
                      .locale('ja')
                      .format('YYYY年MM月DD日（ddd）')})`
                : null,
        ...cloneMapShortCodeFaq(ac)
    };
    array.forEach((item) => {
        item.answer = tranferShortCode(item.answer, shortCodeAMap);
        item.pattern = tranferShortCode(item.pattern, shortCodeAMap);
    });
    return array;
}

function funcConditionLabel(label) {
    return (
        label !== i18n.t('document.winningDistributionText') &&
        label !== i18n.t('document.faq') &&
        label !== i18n.t('document.customizeItYourself') &&
        label !== i18n.t('document.manual')
    );
}

function handleDataAllRule(
    data,
    listConditionRuleDetail,
    listDataMasterRuleGeneral,
    listDataMasterRuleGeneralCheck,
    listDataMasterRuleClose,
    listDataMasterRuleCloseCheck,
    dataRuleTab2,
    dataRuleTab2Check
) {
    listConditionRuleDetail = data.data;
    data.data.forEach((item) => {
        if (item.type == 1) {
            item.rules = [];
            listDataMasterRuleGeneral.push(item);
            listDataMasterRuleGeneralCheck.platform.push(item);
        } else if (item.type == 2) {
            item.rules = [];
            listDataMasterRuleClose.push(item);
            listDataMasterRuleCloseCheck.platform.push(item);
        } else {
            item.rules = [];
            if (item.platforms.length > 0) {
                item.platforms.forEach((pl) => {
                    if (!Array.isArray(dataRuleTab2[pl.id])) {
                        dataRuleTab2[pl.id] = [];
                    }
                    dataRuleTab2[pl.id].push(item);
                });
            }
            dataRuleTab2Check = JSON.parse(JSON.stringify(dataRuleTab2));
        }
    });

    return {
        listConditionRuleDetail,
        listDataMasterRuleGeneral,
        listDataMasterRuleGeneralCheck,
        listDataMasterRuleClose,
        listDataMasterRuleCloseCheck,
        dataRuleTab2,
        dataRuleTab2Check
    };
}

function initFileDocs() {
    return [
        {
            id: 1,
            label: '立ち上げ資料関連',
            children: [
                {
                    id: 1,
                    label: i18n.t('document.rule'),
                    children: [
                        {
                            id: 1,
                            label: '',
                            parent_label: i18n.t('document.rule'),
                            data: [
                                {
                                    id: '47',
                                    source: 'rule',
                                    name: '【規約】キャンペーン名_作成年月日.docx',
                                    client: null,
                                    rules: [],
                                    rule_details: [],
                                    platforms: [],
                                    platformsSend: []
                                }
                            ]
                        }
                    ]
                },
                {
                    id: 2,
                    label: i18n.t('document.manual'),
                    children: [
                        {
                            id: 1,
                            label: '',
                            parent_label: i18n.t('document.manual'),
                            data: [
                                {
                                    id: '5',
                                    source: 'horizontal_manual',
                                    name: '横・【事務局マニュアル】 CP名_yyyymmdd.pptx',
                                    client: null,
                                    client_type: null,
                                    partner: null
                                },
                                {
                                    id: '6',
                                    source: 'vertical_manual',
                                    name: '縦・【事務局マニュアル】 CP名_yyyymmdd.pptx',
                                    client: null,
                                    client_type: null,
                                    partner: null
                                }
                            ]
                        }
                    ]
                },
                {
                    id: 3,
                    label: i18n.t('document.faq'),
                    children: [
                        {
                            id: 1,
                            label: '',
                            parent_label: i18n.t('document.faq'),
                            data: [
                                {
                                    id: '20',
                                    source: 'faq',
                                    name: '雛形CL※【FAQ】CP名_yyyymmdd.xlsx',
                                    preview: true
                                }
                            ]
                        }
                    ]
                },
                {
                    id: 4,
                    label: i18n.t('document.schedule'),
                    children: [
                        {
                            id: 1,
                            label: '',
                            parent_label: i18n.t('document.schedule'),
                            data: [
                                {
                                    id: '13',
                                    source: 'schedule',
                                    name: '【スケジュール】キャンペーン名',
                                    conditions: {
                                        fmt_parameter_settings: {
                                            delivery_cycle: cycleFMT[0],
                                            closing_day: null,
                                            report_day: null,
                                            is_skip_the_first_week: false,
                                            is_merged_with_the_last_week: false
                                        },
                                        fmt_contact_agency_settings: {
                                            delivery_cycle: cycleFMT[0],
                                            closing_day: null,
                                            report_day: null,
                                            is_skip_the_first_week: false,
                                            is_merged_with_the_last_week: false
                                        }
                                    }
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: 2,
            label: 'FMT関連',
            children: [
                {
                    id: 1,
                    label: i18n.t('document.mumberOfMessagesFMT'),
                    children: [
                        {
                            id: 1,
                            label: '',
                            parent_label: i18n.t('document.mumberOfMessagesFMT'),
                            data: [
                                {
                                    id: '22',
                                    source: 'fmt_parameter',
                                    name: '【応募数報告】《キャンペーン名》_出力日付',
                                    conditions: {
                                        campaign_start_date: '',
                                        campaign_end_date: '',
                                        categories: '',
                                        cycle: cycleFMT[0],
                                        closing_date: null,
                                        report_date: null,
                                        skip_the_first_week_closing: false,
                                        include_it_one_week_before: false
                                    }
                                }
                            ]
                        }
                    ]
                },
                {
                    id: 2,
                    label: i18n.t('document.contactFMT'),
                    children: [
                        {
                            id: 1,
                            label: '',
                            parent_label: i18n.t('document.contactFMT'),
                            data: [
                                {
                                    id: '26',
                                    source: 'fmt_agency',
                                    name: '【問い合せ報告】●●●キャンペーン__yyyymmdd　祝日一覧無し.xlsx',
                                    conditions: {
                                        campaign_start_date: '',
                                        campaign_end_date: '',
                                        cycle: cycleFMT[0],
                                        closing_date: null,
                                        report_date: null,
                                        skip_the_first_week_closing: false,
                                        include_it_one_week_before: false
                                    }
                                },
                                {
                                    id: '27',
                                    source: 'fmt_entire_company',
                                    name: '※社内全体用※【問い合せ報告】 ●●●キャンペーン__yyyymmdd　祝日一覧無し.xlsx',
                                    conditions: {
                                        campaign_start_date: '',
                                        campaign_end_date: '',
                                        cycle: cycleFMT[0],
                                        closing_date: null,
                                        report_date: null,
                                        skip_the_first_week_closing: false,
                                        include_it_one_week_before: false
                                    }
                                }
                            ]
                        }
                    ]
                },
                {
                    id: 3,
                    label: i18n.t('document.escalation'),
                    children: [
                        {
                            id: 1,
                            label: '',
                            parent_label: i18n.t('document.escalation'),
                            data: [
                                {
                                    id: '1',
                                    source: 'escalation',
                                    name: '【エスカレーション】 ●●●キャンペーン_yyyymmdd.xlsx'
                                },
                                {
                                    id: '2',
                                    source: 'escalation_for_partner',
                                    name: '※パートナー用※【エスカレーション】 ●●●キャンペーン_yyyymmdd.xlsx'
                                },
                                {
                                    id: '3',
                                    source: 'escalation_for_internal',
                                    name: '※社内用※【エスカレーション】 ●●●キャンペーン_yyyymmdd.xlsx'
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: 3,
            label: '文書関連',
            children: [
                {
                    id: 1,
                    label: i18n.t('document.greetingCard'),
                    children: [
                        {
                            id: 1,
                            label: '',
                            parent_label: i18n.t('document.greetingCard'),
                            data: [
                                {
                                    id: '7',
                                    name: '※POP※【挨拶状】_●●●CP_yyyymmdd.pptx',
                                    source: 'pop_greeting_card',
                                    client: null,
                                    image_pre: '/images/gettingcard/pop_greeting_card.png'
                                },
                                {
                                    id: '8',
                                    source: 'flower_greeting_card',
                                    name: '※お花※【挨拶状】_●●●CP_yyyymmdd.pptx',
                                    client: null,
                                    image_pre: '/images/gettingcard/flower_greeting_card.png'
                                },
                                {
                                    id: '9',
                                    source: 'luxury_greeting_card',
                                    name: '※高級感※【挨拶状】_●●●CP_yyyymmdd.pptx',
                                    client: null,
                                    image_pre: '/images/gettingcard/luxury_greeting_card.png'
                                },
                                {
                                    id: '10',
                                    source: 'normal_with_replacement_greeting_card',
                                    name: '※差換え無し※【挨拶状】_●●●CP_yyyymmdd.pptx',
                                    client: null,
                                    image_pre: '/images/gettingcard/normal_with_replacement_greeting_card.png'
                                },
                                {
                                    id: '11',
                                    source: 'normal_without_replacement_greeting_card',
                                    name: '※差換え有※(賞名orコース)【挨拶状】_●●●CP_yyyymmdd.pptx',
                                    client: null,
                                    image_pre: '/images/gettingcard/normal_without_replacement_greeting_card.png'
                                }
                            ]
                        }
                    ]
                },
                {
                    id: 2,
                    label: i18n.t('document.winningDistributionText'),
                    children: [
                        {
                            id: 1,
                            type: 3,
                            label: '基本 ',
                            parent_label: i18n.t('document.winningDistributionText'),
                            data: []
                        },
                        {
                            id: 2,
                            type: 2,
                            label: 'デジタル',
                            parent_label: i18n.t('document.winningDistributionText'),
                            data: []
                        },
                        {
                            id: 3,
                            type: 1,
                            label: 'イベント',
                            parent_label: i18n.t('document.winningDistributionText'),
                            data: []
                        }
                    ],
                    data: []
                }
            ]
        },
        {
            id: 4,
            label: 'その他',
            children: [
                {
                    id: 1,
                    label: i18n.t('document.PDCA'),
                    children: [
                        {
                            id: 1,
                            label: '',
                            parent_label: i18n.t('document.PDCA'),
                            data: [
                                {
                                    id: '4',
                                    source: 'pdca',
                                    name: 'PDCAアポ提案資料.pptx'
                                }
                            ]
                        }
                    ]
                },
                {
                    id: 2,
                    label: i18n.t('document.partnerRequestSheet'),
                    children: [
                        {
                            id: 1,
                            label: '',
                            parent_label: i18n.t('document.partnerRequestSheet'),
                            data: [{}]
                        }
                    ]
                },
                {
                    id: 3,
                    label: i18n.t('document.customizeItYourself'),
                    children: [
                        {
                            id: 1,
                            label: '',
                            parent_label: i18n.t('document.customizeItYourself'),
                            data: []
                        }
                    ]
                }
            ]
        }
    ];
}

function handMapDataDocument2(listFile, conditions) {
    let state = { check: true };
    let documents = [];
    processFiles(listFile, conditions, documents, state);
    return {
        check: state.check,
        documents
    };
}
function processFiles(fileList, conditions, documents, state) {
    const dataParamaterFMT = store.getters['master/dataParamaterFMT'];
    const dataContactFMT = store.getters['master/dataContactFMT'];
    fileList.forEach((file) => {
        if (file.children) {
            // Nếu có children, đệ quy vào
            processFiles(file.children, conditions, documents, state);
        } else if (file.data) {
            // Nếu là data (không còn children)
            file.data.forEach((dataFile) => {
                if (conditions[dataFile.id]) {
                    if (!['エスカレーション', 'PDCAアポ資料'].includes(file.parent_label)) {
                        switch (file.parent_label) {
                            case i18n.t('document.termsAndConditions'):
                                if (!dataFile.rules.length) state.check = false;
                                documents.push({
                                    source: dataFile.source,
                                    data: {
                                        client_id: dataFile?.client?.client_id ?? '',
                                        rules: dataFile.rules
                                    }
                                });
                                break;
                            case i18n.t('document.rule'):
                                if (!dataFile.client) state.check = false;
                                documents.push({
                                    source: dataFile.source,
                                    data: {
                                        client_id: dataFile?.client?.client_id ?? '',
                                        rules: dataFile.rules,
                                        platforms: dataFile.platformsSend,
                                        rule_details: dataFile.rule_details?.map((item) => item.id)
                                    }
                                });
                                break;

                            case i18n.t('document.schedule'):
                                if (!dataFile?.conditions?.campaign_start_date || !dataFile?.conditions?.titles?.length) {
                                    state.check = false;
                                    return;
                                }
                                delete dataFile.conditions.parentID;
                                delete dataFile.conditions.categories;
                                documents.push({
                                    source: dataFile.source,
                                    data: {
                                        ...dataFile.conditions,
                                        fmt_parameter_settings: dataFile.conditions.fmt_parameter_settings
                                            ? {
                                                  delivery_cycle: dataParamaterFMT?.delivery_cycle ?? 1,
                                                  report_day: dataParamaterFMT?.report_day ?? 3,
                                                  closing_day: dataParamaterFMT?.delivery_cycle === 1 ? dataParamaterFMT?.closing_day?.id : null,
                                                  is_skip_the_first_week: dataParamaterFMT?.is_skip_the_first_week ?? false,
                                                  is_merged_with_the_last_week: dataParamaterFMT?.is_merged_with_the_last_week ?? false
                                              }
                                            : null,
                                        fmt_contact_agency_settings: dataFile.conditions.fmt_contact_agency_settings
                                            ? {
                                                  delivery_cycle: dataContactFMT?.delivery_cycle ?? 1,
                                                  report_day: dataContactFMT?.report_day ?? 3,
                                                  closing_day: dataContactFMT?.delivery_cycle === 1 ? dataContactFMT?.closing_day?.id : null,
                                                  is_skip_the_first_week: dataContactFMT?.is_skip_the_first_week ?? false,
                                                  is_merged_with_the_last_week: dataContactFMT?.is_merged_with_the_last_week ?? false
                                              }
                                            : null
                                    }
                                });
                                break;

                            case 'FAQ':
                                documents.push({
                                    source: dataFile.source,
                                    data: {}
                                });
                                break;

                            case i18n.t('document.manual'):
                                documents.push({
                                    source: dataFile.source,
                                    data: {
                                        client_id: dataFile.client?.client_id ?? '',
                                        client_type_agency_id: dataFile.client_type?.id ?? '',
                                        partner_shipping_id: dataFile.partner?.id ?? ''
                                    }
                                });
                                break;

                            case i18n.t('document.mumberOfMessagesFMT'):
                                if (!dataFile?.conditions?.campaign_start_date || !dataFile?.conditions?.campaign_end_date) {
                                    state.check = false;
                                }
                                documents.push({
                                    source: dataFile.source,
                                    data: {
                                        delivery_cycle: dataParamaterFMT?.delivery_cycle ?? 1,
                                        report_day: dataParamaterFMT?.report_day ?? 3,
                                        closing_day: dataParamaterFMT?.delivery_cycle === 1 ? dataParamaterFMT?.closing_day?.id : null,
                                        is_skip_the_first_week: dataParamaterFMT?.is_skip_the_first_week ?? false,
                                        is_merged_with_the_last_week: dataParamaterFMT?.is_merged_with_the_last_week ?? false
                                    }
                                });
                                break;
                            case i18n.t('document.contactFMT'):
                                if (!dataFile?.conditions?.campaign_start_date || !dataFile?.conditions?.campaign_end_date) {
                                    state.check = false;
                                }
                                documents.push({
                                    source: dataFile.source,
                                    data: {
                                        delivery_cycle: dataContactFMT?.delivery_cycle ?? 1,
                                        report_day: dataContactFMT?.report_day ?? 3,
                                        closing_day: dataContactFMT?.delivery_cycle === 1 ? dataContactFMT?.closing_day?.id : null,
                                        is_skip_the_first_week: dataContactFMT?.is_skip_the_first_week ?? false,
                                        is_merged_with_the_last_week: dataContactFMT?.is_merged_with_the_last_week ?? false
                                    }
                                });
                                break;
                            default:
                                if (!dataFile.client && funcConditionLabel(file.parent_label)) {
                                    state.check = false;
                                }
                                documents.push({
                                    source: dataFile.source,
                                    data: {
                                        client_id: dataFile?.client?.client_id ?? ''
                                    }
                                });
                        }
                    } else {
                        documents.push({
                            source: dataFile.source,
                            data: {}
                        });
                    }
                }
            });
        }
    });
}

function onHandleMapCheckSchedule(data, objExportSchedule, listDataTypeOne, listDataPlatform) {
    const dataTitleObjSchedule = objExportSchedule?.titles ?? [];
    listDataTypeOne.forEach((dataType) => {
        data.forEach((campaignType) => {
            if (campaignType.type === dataType.type) {
                dataType.works.forEach((work) => {
                    const matchedWork = campaignType.works.find((w) => w.id === work.id);
                    if (matchedWork) {
                        work.checked = matchedWork.is_check;
                    }
                    if (dataTitleObjSchedule.length > 0) {
                        work.checked = dataTitleObjSchedule.includes(work.id);
                    }
                });
            }
        });
    });

    listDataPlatform.forEach((platform) => {
        data.forEach((campaignType) => {
            if (campaignType.type === platform.type) {
                platform.works.forEach((work) => {
                    const matchedWork = campaignType.works.find((x) => x.id === work.id);
                    if (matchedWork) {
                        work.checked = matchedWork.is_check;
                    }
                    if (dataTitleObjSchedule.length > 0) {
                        work.checked = dataTitleObjSchedule.includes(work.id);
                    }
                });
            }
        });
    });
}

function convertNtoBr(text) {
    if (typeof text !== 'string') return text;
    return text.replace(/\n/g, '<br>');
}

function convertBrToN(text) {
    if (typeof text !== 'string') return text;
    return text.replace(/<br\s*\/?>/gi, '\n');
}

function mapDataPlatformPrv(keyData, valueData, getType = 'keyAndValue', typeFormat = '</br>') {
    if (!valueData || !keyData) return null;
    // eslint-disable-next-line no-prototype-builtins
    if (!valueData.hasOwnProperty(keyData)) return;
    if (getType === 'key' && valueData[keyData]) return keyData ?? '';
    if (getType === 'value' && valueData[keyData]) return valueData[keyData] ?? '';
    if (!keyData || (!valueData && !valueData[keyData] && valueData[keyData]?.length <= 0)) return '';
    const convertedBr = Array.isArray(valueData[keyData])
        ? valueData[keyData]?.map((item) => (typeFormat === '\n' ? convertBrToN(item) : convertNtoBr(item)))
        : typeFormat === '\n'
          ? convertBrToN(valueData[keyData])
          : convertNtoBr(valueData[keyData]);
    if (!convertedBr || valueData[keyData]?.length <= 0 || valueData[keyData][0] === '') return keyData;
    if (typeof valueData[keyData] === 'string') return `${keyData}: ${convertedBr}`;
    return `${keyData}: ${convertedBr?.join('・') ?? ''}`;
}

function onHandleListUnique(listUnique) {
    if (!listUnique || listUnique.length <= 0) return [];
    return listUnique.filter((item, index, arr) => arr.findIndex((i) => i.toLowerCase() === item.toLowerCase()) === index);
}

function mapDataPlatformPartnerAndToolPrv(keyData, valueData, getType = 'keyAndValue', typeFormat = '</br>') {
    if (!valueData || !keyData) return null;
    // eslint-disable-next-line no-prototype-builtins
    if (!valueData.hasOwnProperty(keyData)) return;
    if (getType === 'key' && valueData[keyData]) return keyData ?? '';
    if (getType === 'value' && valueData[keyData]) return valueData[keyData] ?? '';
    if (!keyData || (!valueData && !valueData[keyData] && valueData[keyData]?.length <= 0)) return '';
    const convertedBr = Array.isArray(valueData[keyData])
        ? onHandleListUnique(valueData[keyData]).map((item) => (typeFormat === '\n' ? convertBrToN(item) : convertNtoBr(item)))
        : typeFormat === '\n'
          ? convertBrToN(valueData[keyData])
          : convertNtoBr(valueData[keyData]);
    if (!convertedBr || valueData[keyData]?.length <= 0 || valueData[keyData][0] === '') return keyData;
    if (typeof valueData[keyData] === 'string') return `${keyData}: ${convertedBr}`;
    return `${convertedBr?.join(typeFormat) ?? ''}`;
}
function formatObjectEntries(data, typeFormat = '</br') {
    if (!data) return;
    return Object.entries(data)
        .map(([title, item]) => {
            if (item.length > 0) {
                if (Array.isArray(item)) {
                    return `${title}${typeFormat}${item.map((p) => `-${typeFormat === '\n' ? convertBrToN(p) : convertNtoBr(p)}`).join(typeFormat)}`;
                } else {
                    return `${title}${typeFormat}${typeFormat === '\n' ? convertBrToN(item) : convertNtoBr(item)}`;
                }
            }
            return title;
        })
        .join(typeFormat);
}

function formatObjecOrderScope(data, characterFormat = '</br>', typeFormat = '</br') {
    if (!data) return;
    return Object.entries(data)
        .map(([title, scopers]) => {
            if (scopers.length > 0) {
                if (Array.isArray(scopers)) {
                    // eslint-disable-next-line no-irregular-whitespace
                    return `${title}${typeFormat}${scopers.map((p) => `　-${typeFormat === '\n' ? convertBrToN(p) : convertNtoBr(p)}`).join(characterFormat)}`;
                } else {
                    // eslint-disable-next-line no-irregular-whitespace
                    return `${title}${typeFormat}　-${typeFormat === '\n' ? convertBrToN(scopers) : convertNtoBr(scopers)}`;
                }
            }
            return title;
        })
        .join(typeFormat);
}

function formatObjecKeyOrderScope(key, data, typeFormat = '</br') {
    if (!data) return;
    if (!data[key] || data[key]?.length <= 0) return;
    if (data[key].length > 0) {
        if (Array.isArray(data[key])) {
            // eslint-disable-next-line no-irregular-whitespace
            return `${key}${typeFormat}${data[key].map((p) => `　-${typeFormat === '\n' ? convertBrToN(p) : convertNtoBr(p)}`).join(typeFormat)}`;
        } else {
            // eslint-disable-next-line no-irregular-whitespace
            return `${key}${typeFormat}　-${typeFormat === '\n' ? convertBrToN(data[key]) : convertNtoBr(data[key])}`;
        }
    }
}

function formatObjectCommon(data, typeFormat = '</br>') {
    if (!data) return;
    return Object.entries(data)
        .map(([title, items]) => {
            if (items && items?.length > 0) {
                if (Array.isArray(items)) {
                    return `${title}：${items.map((p) => (typeFormat === '\n' ? convertBrToN(p) : convertNtoBr(p))).join('・')}`;
                } else {
                    return `${title}：${typeFormat === '\n' ? convertBrToN(items) : convertNtoBr(items)}`;
                }
            }
            return title;
        })
        .join(typeFormat);
}

function mapSourceContact(contactData, contextData, typeFormat = '</br>') {
    if (!contactData || !contextData) return;
    let { name, tel, email, secretariat_start_date, secretariat_end_date, is_affected_by_year_end, year_end_schedule_from, year_end_schedule_to } =
        contextData;
    const shortContact = {
        お問い合わせ事務局名: name ? `${name}事務局` : '《お問い合わせ事務局名》',
        キャンペーン事務局TEL: tel ?? '《キャンペーン事務局TEL》',
        キャンペーン事務局Mailアドレス: email ?? '《キャンペーン事務局Mailアドレス》',
        事務局開始時間: secretariat_start_date ? formatDateCommon(secretariat_start_date, 'YYYMMDDHHmm') : '《事務局開始時間》',
        事務局終了時間: secretariat_end_date ? formatDateCommon(secretariat_end_date, 'YYYMMDDHHmm') : '《事務局終了時間》',
        年末年始休み: is_affected_by_year_end
            ? `・年末年始(${formatDateCommon(year_end_schedule_from, 'everyDay')} ~ ${formatDateCommon(year_end_schedule_to, 'everyDay')})`
            : '《年末年始休み》',
        事務局終了日: secretariat_end_date ? formatDateCommon(secretariat_end_date, 'everyDay') : '《事務局終了日》'
    };
    const resultTranfer = tranferShortCode(contactData, shortContact);
    return typeFormat === '\n' ? convertBrToN(resultTranfer) : convertNtoBr(resultTranfer);
}

function onHandleFormatEventPrize(data, typeFormat = '</br') {
    if (!data || data?.length <= 0) return;
    const formatPrize = data
        .map((item) => {
            return onHandleListUnique([item.title, ...item.prizes?.map((p) => p.name), `${item?.number_of_win_prize ?? 0}名`]).join(typeFormat);
        })
        .join(typeFormat);
    return formatPrize;
}

function handleTranferShortCodePreview(data) {
    let {
        name,
        campaign_start_date,
        tel,
        email,
        is_tel,
        is_email,
        secretariat_start_date,
        secretariat_end_date,
        year_end_schedule_from,
        year_end_schedule_to,
        is_affected_by_year_end,
        LINEポイント,
        PayPay,
        Amazonギフト,
        アプリポイント,
        QUOカードPay,
        えらべるPay,
        client_name,
        prize_titles,
        condition_postcard,
        condition1_values,
        condition2_values,
        application_methods,
        offical_name_sns,
        offical_id_sns,
        platform_name_ids,
        contact_information_name_ids,
        hashtags,
        purchase_conditions,
        target_product_default,
        target_product_child,
        target_product_all,
        inform,
        url,
        campaign_url,
        url_publish_time_from,
        url_publish_time_to,
        information_ip,
        sponsor_information,
        sponsor_information_tie_up,
        sponsor_information_detail,
        total_number_of_win_prize,
        shipping_period,
        prize_shipping_period,
        contact,
        folder_project,
        folder_quotation,
        order_scope_large,
        order_scope_medium,
        order_scope_detail,
        order_scope_partner,
        order_scope_partner_all,
        order_scope_tool_all,
        order_scope_tool,
        partner_shipping_address,
        client_generate_file_pic,
        client_order_source_pic,
        manufacturer_clients,
        distribution_clients,
        sale_staff,
        person_in_charge,
        sub,
        project_manager,
        customer_team_pic,
        parttime_employee,
        customer_sub_person,
        event_prizes,
        event_prize_title_name,
        event_prize_title_number_win_prize,
        event_prize_title_number_win_draw,
        event_prize_title_number_win_type,
        prize_display,
        number_of_applications,
        number_of_inquiry,
        number_of_inquiry_with_total,
        platform_followers_number,
        progress_status,
        zac_id,
        sfid,
        campaign_type,
        categories,
        campaign_end_date,
        receipt_expiration_start_date,
        receipt_expiration_end_date,
        partner_address,
        partner_postcard_collection_address,
        order_source_name,
        campaign_entity_id,
        social_platforms,
        forms,
        form_public_urls
    } = data.data.context_data;
    const linkPublish = `https://${process.env.VUE_APP_DOMAIN_FORM}/form`;
    const getListForm = form_public_urls?.length ? form_public_urls : forms?.map((formItem) => `${linkPublish}/${formItem.url_public}`) || [];
    const getContactInfo = (tel, email, is_tel, is_email) => {
        if (is_tel && is_email) {
            return `【TEL】: ${tel || ''}</br>【MAIL】: ${email || ''}`;
        } else if (is_tel && !is_email) {
            return `【TEL】: ${tel || ''}`;
        } else if (is_email && !is_tel) {
            return `【MAIL】: ${email || ''}`;
        }
        return '《キャンペーン事務局連絡先》';
    };
    const prizeReplacements = {
        キャンペーン名: name || '《キャンペーン名》',
        キャンペーン開始: campaign_start_date ? formatDateCommon(campaign_start_date, 'everyDayHHmm') : '《キャンペーン開始》',
        事務局開始: secretariat_start_date ? formatDateCommon(secretariat_start_date, 'everyDayHHmm') : '《事務局開始》',
        事務局終了: secretariat_end_date ? formatDateCommon(secretariat_end_date, 'everyDayHHmm') : '《事務局終了》',
        年末年始休み: is_affected_by_year_end
            ? `・年末年始(${formatDateCommon(year_end_schedule_from, 'everyDay')} ~ ${formatDateCommon(year_end_schedule_to, 'everyDay')})`
            : '',

        // shot code winningDistributionText
        LINEポイント: LINEポイント?.length > 0 ? `（${LINEポイント.join('、')}）` : '（●●円分）',
        PayPayポイント: PayPay?.length > 0 ? `（${PayPay.join('、')}）` : '（●●円分）',
        Amazonギフト: Amazonギフト?.length > 0 ? `（${Amazonギフト.join('、')}）` : '（●●円分）',
        図書カードネットギフト: '（●●円分）',
        EJOICAセレクトギフト:
            data.data.context_data['Ejoica セレクトギフト']?.length > 0
                ? `（${data.data.context_data['Ejoica セレクトギフト'].join('、')}）`
                : '（●●円分）',
        nanacoギフト: '（●●円分）',
        クオカードペイ: QUOカードPay?.length > 0 ? `（${QUOカードPay.join('、')}）` : '（●●円分）',
        えらべるPay: えらべるPay?.length > 0 ? `（${えらべるPay.join('、')}）` : '（●●円分）',
        // end shot code winningDistributionText

        LINEのポイント: LINEポイント?.length > 0 ? LINEポイント.join('、') : '《LINEのポイント》',
        PayPayのポイント: PayPay?.length > 0 ? PayPay.join('、') : '《PayPayのポイント》',
        Amazonのギフト: Amazonギフト?.length > 0 ? Amazonギフト.join('、') : '《Amazonのギフト》',
        図書カードネットのギフト: '《図書カードネットのギフト》',
        nanacoのギフト: '《nanacoのギフト》',
        'App Store &amp; iTunes ギフトカード': アプリポイント?.length > 0 ? アプリポイント.join('、') : '（●●円分）',
        QUOのカードPay: QUOカードPay?.length > 0 ? QUOカードPay.join('、') : '《QUOのカードPay》',
        えらべるのPay: えらべるPay?.length > 0 ? えらべるPay.join('、') : '《えらべるのPay》',
        EJOICAセレクトのギフト:
            data.data.context_data['Ejoica セレクトギフト']?.length > 0
                ? data.data.context_data['Ejoica セレクトギフト'].join('、')
                : '《EJOICAセレクトのギフト》',
        クライアント名: client_name || '《クライアント名》',
        キャンペーン事務局連絡先: getContactInfo(tel, email, is_tel, is_email),
        タイトル賞品: prize_titles.length > 0 ? prize_titles.join('、') : '《タイトル賞品》',
        ハガキ有効条件: condition_postcard ?? '《ハガキ有効条件》',
        'WEB：応募フォームURL': getListForm?.length > 0 ? getListForm.join('、') : '《WEB：応募フォームURL》',
        ステータス: progress_status ?? '《ステータス》',
        'WEB：応募条件①': mapDataPlatformPrv('WEB', condition1_values) ?? '《WEB：応募条件①》',
        'ハガキ：応募条件①': mapDataPlatformPrv('ハガキ', condition1_values) ?? '《ハガキ：応募条件①》',
        'X：応募条件①': mapDataPlatformPrv('X', condition1_values) ?? '《X：応募条件①》',
        'Instagram：応募条件①': mapDataPlatformPrv('Instagram', condition1_values) ?? '《Instagram：応募条件①》',
        'LINE：応募条件①': mapDataPlatformPrv('LINE', condition1_values) ?? '《LINE：応募条件①》',
        'TikTok：応募条件①': mapDataPlatformPrv('TikTok', condition1_values) ?? '《TikTok：応募条件①》',
        '店頭：応募条件①': mapDataPlatformPrv('店頭', condition1_values) ?? '《店頭：応募条件①》',
        'アプリ：応募条件①': mapDataPlatformPrv('アプリ', condition1_values) ?? '《アプリ：応募条件①》',

        '共通：応募条件①': condition1_values ? formatObjectCommon(condition1_values) : '《共通：応募条件①》',
        '共通：応募条件②': condition2_values ? formatObjectCommon(condition2_values) : '《共通：応募条件②》',
        'WEB：応募条件②': mapDataPlatformPrv('WEB', condition2_values) ?? '《WEB：応募条件②》',
        'ハガキ：応募条件②': mapDataPlatformPrv('ハガキ', condition2_values) ?? '《ハガキ：応募条件②》',
        'X：応募条件②': mapDataPlatformPrv('X', condition2_values) ?? '《X：応募条件②》',
        'Instagram：応募条件②': mapDataPlatformPrv('Instagram', condition2_values) ?? '《Instagram：応募条件②》',
        'LINE：応募条件②': mapDataPlatformPrv('LINE', condition2_values) ?? '《LINE：応募条件②》',
        'TikTok：応募条件②': mapDataPlatformPrv('TikTok', condition2_values) ?? '《TikTok：応募条件②》',
        '店頭：応募条件②': mapDataPlatformPrv('店頭', condition2_values) ?? '《店頭：応募条件②》',
        'アプリ：応募条件②': mapDataPlatformPrv('アプリ', condition2_values) ?? '《アプリ：応募条件②》',

        'WEB：応募方法': mapDataPlatformPrv('WEB', application_methods) ?? '《WEB：応募方法》',
        'ハガキ：応募方法': mapDataPlatformPrv('ハガキ', application_methods) ?? '《ハガキ：応募方法》',
        'X：応募方法': mapDataPlatformPrv('X', application_methods) ?? '《X：応募方法》',
        'Instagram：応募方法': mapDataPlatformPrv('Instagram', application_methods) ?? '《Instagram：応募方法》',
        'LINE：応募方法': mapDataPlatformPrv('LINE', application_methods) ?? '《LINE：応募方法》',
        'TikTok：応募方法': mapDataPlatformPrv('TikTok', application_methods) ?? '《TikTok：応募方法》',
        '店頭：応募方法': mapDataPlatformPrv('店頭', application_methods) ?? '《店頭：応募方法》',
        'アプリ：応募方法': mapDataPlatformPrv('アプリ', application_methods) ?? '《アプリ：応募方法》',
        '共通：応募方法': application_methods ? formatObjectCommon(application_methods) : '《共通：応募方法》',

        'X：公式アカウント名': mapDataPlatformPrv('X', offical_name_sns) ?? '《X：公式アカウント名》',
        'Instagram：公式アカウント名': mapDataPlatformPrv('Instagram', offical_name_sns) ?? '《Instagram：公式アカウント名》',
        'LINE：公式アカウント名': mapDataPlatformPrv('LINE', offical_name_sns) ?? '《LINE：公式アカウント名》',
        'TikTok：公式アカウント名': mapDataPlatformPrv('TikTok', offical_name_sns) ?? '《TikTok：公式アカウント名》',

        'X：公式アカウントID': mapDataPlatformPrv('X', offical_id_sns) ?? '《X：公式アカウントID》',
        'Instagram：公式アカウントID': mapDataPlatformPrv('Instagram', offical_id_sns) ?? '《Instagram：公式アカウントID》',
        'LINE：公式アカウントID': mapDataPlatformPrv('LINE', offical_id_sns) ?? '《LINE：公式アカウントID》',
        'TikTok：公式アカウントID': mapDataPlatformPrv('TikTok', offical_id_sns) ?? '《TikTok：公式アカウントID》',

        'X：公式アカウント名＆ID': mapDataPlatformPrv('X', platform_name_ids) ?? '《X：公式アカウント名＆ID》',
        'Instagram：公式アカウント名＆ID': mapDataPlatformPrv('Instagram', platform_name_ids) ?? '《Instagram：公式アカウント名＆ID》',
        'LINE：公式アカウント名＆ID': mapDataPlatformPrv('LINE', platform_name_ids) ?? '《LINE：公式アカウント名＆ID》',
        'TikTok：公式アカウント名＆ID': mapDataPlatformPrv('TikTok', platform_name_ids) ?? '《TikTok：公式アカウント名＆ID》',
        '共通：公式アカウント名＆ID': platform_name_ids ? formatObjectCommon(platform_name_ids) : '《共通：公式アカウント名＆ID》',
        お問い合わせDM対応アカウント: contact_information_name_ids
            ? formatObjectCommon(contact_information_name_ids)
            : '《お問い合わせDM対応アカウント》',

        'X：ハッシュタグ': mapDataPlatformPrv('X', hashtags) ?? '《X：ハッシュタグ》',
        'Instagram：ハッシュタグ': mapDataPlatformPrv('Instagram', hashtags) ?? '《Instagram：ハッシュタグ》',
        'TikTok：ハッシュタグ': mapDataPlatformPrv('TikTok', hashtags) ?? '《TikTok：ハッシュタグ》',
        '共通：ハッシュタグ': hashtags ? formatObjectCommon(hashtags) : '《共通：ハッシュタグ》',

        対象商品金額: mapDataPlatformPrv('対象商品(金額)', purchase_conditions) ?? '《対象商品金額》',
        対象商品個数: mapDataPlatformPrv('対象商品(個数)', purchase_conditions) ?? '《対象商品個数》',
        対象商品合計金額: mapDataPlatformPrv('対象商品合計金額', purchase_conditions) ?? '《対象商品合計金額》',
        流通合計金額: mapDataPlatformPrv('流通合計金額', purchase_conditions) ?? '《流通合計金額》',
        購買条件: purchase_conditions ? Object.keys(purchase_conditions).join('</br>') : '《購買条件》',
        購買条件と金額詳細: purchase_conditions ? formatObjectCommon(purchase_conditions) : '《購買条件と金額詳細》',

        対象商品カテゴリ1: target_product_default ? Object.keys(target_product_default).join('</br>') : '《対象商品カテゴリ1》',
        対象商品カテゴリ2: target_product_default ? formatObjectCommon(target_product_default) : '《対象商品カテゴリ2》',

        商品関連自由入力: target_product_child ? formatObjectCommon(target_product_child) : '《商品関連自由入力》',

        '共通：対象商品カテゴリ': target_product_all ? formatObjectCommon(target_product_all) : '《共通：対象商品カテゴリ》',
        キャンペーン告知: inform ?? '《キャンペーン告知》',
        LPサイト: url ?? '《LPサイト》',
        公開期間: url_publish_time_from
            ? `${formatDateCommon(url_publish_time_from, 'everyDayHHmm')} ~ ${formatDateCommon(url_publish_time_to, 'everyDayHHmm')}`
            : '《公開期間》',
        IPコンテンツ: information_ip ? Object.keys(information_ip).join('</br>') : '《IPコンテンツ》',
        IPコンテンツ詳細含む: information_ip ? formatObjectCommon(information_ip) : '《IPコンテンツ詳細含む》',
        キャンペーン主催情報: sponsor_information ?? '《キャンペーン主催情報》',
        キャンペーン主催情報詳細含む: convertNtoBr(sponsor_information_tie_up) ?? '《キャンペーン主催情報詳細含む》',
        タイアップ流通数: sponsor_information_detail?.circulation_number
            ? `${sponsor_information_detail?.circulation_number ?? ''}`
            : '《タイアップ流通数》',
        タイアップ流通数報詳細含む:
            sponsor_information_detail?.circulation_number && sponsor_information_detail?.circulation_distribution
                ? `${convertNtoBr(sponsor_information_detail?.circulation_number) ?? ''} </br> 流通詳細：${convertNtoBr(sponsor_information_detail?.circulation_distribution) ?? ''}`
                : '《タイアップ流通数報詳細含む》',
        タイアップメーカー数: sponsor_information_detail?.up_manufacturers
            ? `${sponsor_information_detail?.up_manufacturers ?? ''}`
            : '《タイアップメーカー数》',
        タイアップメーカー数報詳細含む:
            sponsor_information_detail?.up_manufacturers && sponsor_information_detail?.up_manufacturers_name
                ? `${convertNtoBr(sponsor_information_detail?.up_manufacturers) ?? ''} </br> メーカー詳細：${convertNtoBr(sponsor_information_detail?.up_manufacturers_name) ?? ''}`
                : '《タイアップメーカー数報詳細含む》',
        '抽選(当選人数)': total_number_of_win_prize ?? '《抽選(当選人数)》',
        '賞品進呈時期(発送時期・送付時期)':
            shipping_period?.prize_shipping_period && shipping_period?.prize_shipping_period_type
                ? `${shipping_period?.prize_shipping_period ?? ''}${shipping_period?.prize_shipping_period_type ?? ''}`
                : '《賞品進呈時期(発送時期・送付時期)》',
        賞品進呈時期日付部分: prize_shipping_period ?? '《賞品進呈時期日付部分》',
        お問い合わせ事務局名: name ? `${name} 事務局` : '《お問い合わせ事務局名》',
        キャンペーン事務局TEL: tel ?? '《キャンペーン事務局TEL》',
        キャンペーン事務局Mailアドレス: email ?? '《キャンペーン事務局Mailアドレス》',
        キャンペーン事務局MAIL: email ?? '《キャンペーン事務局MAIL》',

        お問い合わせ事務局署名: mapSourceContact(contact, data.data.context_data) ?? '《お問い合わせ事務局署名》',
        案件フォルダ: folder_project ?? '《案件フォルダ》',
        見積もりフォルダ: folder_quotation ?? '《見積もりフォルダ》',

        受注範囲大項目: order_scope_large ? Object.keys(order_scope_large).join('</br>') : '《受注範囲大項目》',
        '受注範囲-資料系': mapDataPlatformPartnerAndToolPrv('資料系', order_scope_large) ?? '《受注範囲-資料系》',
        '受注範囲-お問い合わせ': mapDataPlatformPartnerAndToolPrv('お問い合わせ', order_scope_large) ?? '《受注範囲-お問い合わせ》',
        '受注範囲-応募収集': mapDataPlatformPartnerAndToolPrv('応募収集', order_scope_large) ?? '《受注範囲-応募収集》',
        '受注範囲-事務局関連': mapDataPlatformPartnerAndToolPrv('事務局関連', order_scope_large) ?? '《受注範囲-事務局関連》',
        '受注範囲-発送': mapDataPlatformPartnerAndToolPrv('発送', order_scope_large) ?? '《受注範囲-発送》',
        '受注範囲-制作関連': mapDataPlatformPartnerAndToolPrv('制作関連', order_scope_large) ?? '《受注範囲-制作関連》',
        '受注範囲-SNSアカウント関連': mapDataPlatformPartnerAndToolPrv('SNSアカウント関連', order_scope_large) ?? '《受注範囲-SNSアカウント関連》',
        'パートナー：受注範囲-お問い合わせ':
            mapDataPlatformPartnerAndToolPrv('お問い合わせ', order_scope_partner) ?? '《パートナー：受注範囲-お問い合わせ》',
        'パートナー：受注範囲-応募収集': mapDataPlatformPartnerAndToolPrv('応募収集', order_scope_partner) ?? '《パートナー：受注範囲-応募収集》',
        'パートナー：受注範囲-事務局関連':
            mapDataPlatformPartnerAndToolPrv('事務局関連', order_scope_partner) ?? '《パートナー：受注範囲-事務局関連》',
        'パートナー：受注範囲-発送': mapDataPlatformPartnerAndToolPrv('発送', order_scope_partner) ?? '《パートナー：受注範囲-発送》',
        ツール一覧:
            order_scope_tool_all && order_scope_tool_all?.length > 0 ? onHandleListUnique(order_scope_tool_all)?.join('</br>') : '《ツール一覧》',
        'ツール：受注範囲-応募収集': mapDataPlatformPartnerAndToolPrv('応募収集', order_scope_tool) ?? '《ツール：受注範囲-応募収集》',
        'ツール：受注範囲-事務局関連': mapDataPlatformPartnerAndToolPrv('事務局関連', order_scope_tool) ?? '《ツール：受注範囲-事務局関連》',

        '受注範囲-お問い合わせ+詳細': formatObjecKeyOrderScope('お問い合わせ', order_scope_detail) ?? '《受注範囲-お問い合わせ+詳細》',
        '受注範囲-応募収集+詳細': formatObjecKeyOrderScope('応募収集', order_scope_detail) ?? '《受注範囲-応募収集+詳細》',
        '受注範囲-事務局関連+詳細': formatObjecKeyOrderScope('事務局関連', order_scope_detail) ?? '《受注範囲-事務局関連+詳細》',
        '受注範囲-発送+詳細': formatObjecKeyOrderScope('発送', order_scope_detail) ?? '《受注範囲-発送+詳細》',
        '受注範囲-制作関連+詳細': formatObjecKeyOrderScope('制作関連', order_scope_detail) ?? '《受注範囲-制作関連+詳細》',

        '受注範囲大項目+中項目': formatObjecOrderScope(order_scope_medium, '・') ?? '《受注範囲大項目+中項目》',

        '受注範囲大項目+中項目+詳細': formatObjecOrderScope(order_scope_detail) ?? '《受注範囲大項目+中項目+詳細》',

        '受注範囲-SNSアカウント関連+詳細': formatObjecKeyOrderScope('SNSアカウント関連', order_scope_detail) ?? '《受注範囲-SNSアカウント関連+詳細》',

        パートナー一覧:
            order_scope_partner_all && order_scope_partner_all?.length > 0 ? order_scope_partner_all?.join('</br>') : '《パートナー一覧》',

        はがき回収のパートナー住所: convertNtoBr(partner_address) ?? '《はがき回収のパートナー住所》',
        パートナー会社住所: convertNtoBr(partner_postcard_collection_address) ?? '《パートナー会社住所》',
        発送住所: partner_shipping_address ?? '《発送住所》',
        発注元: order_source_name ?? '《発注元》',
        エンドクライアント担当者: client_generate_file_pic?.name ?? '《エンドクライアント担当者》',
        エンドクライアント担当者メールアドレス: client_generate_file_pic?.email ?? '《エンドクライアント担当者メールアドレス》',
        発注元担当者: client_order_source_pic?.name ?? '《発注元担当者》',
        発注元担当者メールアドレス: client_order_source_pic?.email ?? '《発注元担当者メールアドレス》',
        '主催者(流通)名': manufacturer_clients?.length > 0 ? manufacturer_clients.join('、') : '《主催者(流通)名》',
        協賛メーカー: distribution_clients?.length > 0 ? distribution_clients.join('、') : '《協賛メーカー》',
        営業担当: sale_staff?.name ?? '《営業担当》',
        営業担当メールアドレス: sale_staff?.email ?? '《営業担当メールアドレス》',
        ディレクションメイン担当: person_in_charge?.name ?? '《ディレクションメイン担当》',
        ディレクションメイン担当メールアドレス: person_in_charge?.email ?? '《ディレクションメイン担当メールアドレス》',
        ディレクションサブ１担当: sub[0]?.name ?? '《ディレクションサブ１担当》',
        ディレクションサブ１担当メールアドレス: sub[0]?.email ?? '《ディレクションサブ１担当メールアドレス》',
        ディレクションサブ２担当: sub[1]?.name ?? '《ディレクションサブ２担当》',
        ディレクションサブ２担当メールアドレス: sub[1]?.email ?? '《ディレクションサブ２担当メールアドレス》',
        案件統括: project_manager?.name ?? '《案件統括》',
        案件統括メールアドレス: project_manager?.email ?? '《案件統括メールアドレス》',
        エスカレメイン担当: customer_team_pic?.name ?? '《エスカレメイン担当》',
        エスカレメイン担当メールアドレス: customer_team_pic?.email ?? '《エスカレメイン担当メールアドレス》',
        エスカレサブ担当: customer_sub_person && customer_sub_person?.length > 0 ? customer_sub_person[0]?.name : '《エスカレサブ担当》',
        エスカレサブ担当メールアドレス:
            customer_sub_person && customer_sub_person?.length > 0 ? customer_sub_person[0]?.email : '《エスカレサブ担当メールアドレス》',
        アルバイト: parttime_employee[0]?.name ?? '《アルバイト》',
        賞品タイトル賞品名: event_prize_title_name ? formatObjectEntries(event_prize_title_name) : '《賞品タイトル賞品名》',
        賞品タイトル当選者人数: event_prize_title_number_win_prize
            ? Object.keys(event_prize_title_number_win_prize).join('</br>')
            : '《賞品タイトル当選者人数》',
        賞品タイトル賞品名当選者人数: event_prize_title_number_win_prize
            ? formatObjectEntries(event_prize_title_number_win_prize)
            : '《賞品タイトル賞品名当選者人数》',
        賞品タイトル当選者人数抽選人数: event_prize_title_number_win_draw
            ? Object.keys(event_prize_title_number_win_draw).join('</br>')
            : '《賞品タイトル当選者人数抽選人数》',
        賞品種類: event_prize_title_number_win_type ? formatObjectEntries(event_prize_title_number_win_type) : '《賞品種類》',
        '賞品タイトル-賞品名': onHandleFormatEventPrize(event_prizes) ?? '《賞品タイトル-賞品名》',
        賞品の表示:
            !prize_display || prize_display?.length <= 0
                ? '《賞品の表示》'
                : prize_display
                      .map((item) => {
                          if (item?.is_copy_title_prize) return item?.prize_title;
                          else return `${item?.prize_title}: ${item?.prize_name?.join('、')}`;
                      })
                      .join('</br>'),
        'タイトル・賞品':
            !prize_display || prize_display?.length <= 0
                ? '《タイトル・賞品》'
                : prize_display
                      .map((item) => {
                          if (item?.is_copy_title_prize) return item?.prize_title;
                          else return `${item?.prize_title}</br> ${item?.prize_name?.join('、')}`;
                      })
                      .join('</br>'),

        'WEB：応募数': mapDataPlatformPrv('WEB応募数', number_of_applications) ?? '《WEB：応募数》',
        'ハガキ：応募数': mapDataPlatformPrv('ハガキ応募数', number_of_applications) ?? '《ハガキ：応募数》',
        '店頭：応募数': mapDataPlatformPrv('店頭応募数', number_of_applications) ?? '《店頭：応募数》',
        'アプリ：応募数': mapDataPlatformPrv('アプリ応募数', number_of_applications) ?? '《アプリ：応募数》',
        'Instagram：応募数': mapDataPlatformPrv('Instagram応募数', number_of_applications) ?? '《Instagram：応募数》',
        'LINE：応募数': mapDataPlatformPrv('LINE応募数', number_of_applications) ?? '《LINE：応募数》',
        'X：応募数': mapDataPlatformPrv('X応募数', number_of_applications) ?? '《X：応募数》',
        'TikTok：応募数': mapDataPlatformPrv('TikTok応募数', number_of_applications) ?? '《TikTok：応募数》',
        '共通：応募数': number_of_applications ? formatObjectCommon(number_of_applications) : '《共通：応募数》',

        '電話：お問い合わせ数': mapDataPlatformPrv('電話お問い合わせ数', number_of_inquiry) ?? '《電話：お問い合わせ数》',
        'メール：お問い合わせ数': mapDataPlatformPrv('メールお問い合わせ数', number_of_inquiry) ?? '《メール：お問い合わせ数》',
        'DM：お問い合わせ数': mapDataPlatformPrv('DMお問い合わせ数', number_of_inquiry) ?? '《DM：お問い合わせ数》',
        'その他：お問い合わせ数': mapDataPlatformPrv('その他お問い合わせ数', number_of_inquiry) ?? '《その他：お問い合わせ数》',

        '共通：お問い合わせ数': number_of_inquiry_with_total ? formatObjectCommon(number_of_inquiry_with_total) : '《共通：お問い合わせ数》',
        'WEB：SNSアカウントの友だち・フォロー数':
            mapDataPlatformPrv('WEB', platform_followers_number) ?? '《WEB：SNSアカウントの友だち・フォロー数》',
        'ハガキ：SNSアカウントの友だち・フォロー数':
            mapDataPlatformPrv('ハガキ', platform_followers_number) ?? '《ハガキ：SNSアカウントの友だち・フォロー数》',
        'X：SNSアカウントの友だち・フォロー数': mapDataPlatformPrv('X', platform_followers_number) ?? '《X：SNSアカウントの友だち・フォロー数》',
        'Instagram：SNSアカウントの友だち・フォロー数':
            mapDataPlatformPrv('Instagram', platform_followers_number) ?? '《Instagram：SNSアカウントの友だち・フォロー数》',
        'LINE：SNSアカウントの友だち・フォロー数':
            mapDataPlatformPrv('LINE', platform_followers_number) ?? '《LINE：SNSアカウントの友だち・フォロー数》',
        'TikTok：SNSアカウントの友だち・フォロー数':
            mapDataPlatformPrv('TikTok', platform_followers_number) ?? '《TikTok：SNSアカウントの友だち・フォロー数》',
        '店頭：SNSアカウントの友だち・フォロー数':
            mapDataPlatformPrv('店頭', platform_followers_number) ?? '《店頭：SNSアカウントの友だち・フォロー数》',
        'アプリ：SNSアカウントの友だち・フォロー数':
            mapDataPlatformPrv('アプリ', platform_followers_number) ?? '《アプリ：SNSアカウントの友だち・フォロー数》',

        '共通：SNSアカウントの友だち・フォロー数': platform_followers_number
            ? formatObjectCommon(platform_followers_number)
            : '《共通：SNSアカウントの友だち・フォロー数》',
        '広告関連+媒体＆費用': formatObjectEntries(social_platforms) ?? '《広告関連+媒体＆費用》',
        キャン策ID: campaign_entity_id ?? '《キャン策ID》',
        ZACID: zac_id ?? '《ZACID》',
        SFID: sfid ?? '《SFID》',
        キャンペーン種別: campaign_type ?? '《キャンペーン種別》',
        応募種別: categories && categories?.length > 0 ? categories?.join('、') : '《応募種別》',
        キャンペーン開始日: campaign_start_date ? formatDateCommon(campaign_start_date, 'everyDay') : '《キャンペーン開始日》',
        キャンペーン開始時間: campaign_start_date ? formatDateCommon(campaign_start_date, 'YYYMMDDHHmm') : '《キャンペーン開始時間》',
        キャンペーン終了日: campaign_end_date ? formatDateCommon(campaign_end_date, 'everyDay') : '《キャンペーン終了日》',
        キャンペーン終了時間: campaign_end_date ? formatDateCommon(campaign_end_date, 'YYYMMDDHHmm') : '《キャンペーン終了時間》',
        キャンペーン終了: campaign_end_date ? formatDateCommon(campaign_end_date, 'everyDayHHmm') : '《キャンペーン終了》',
        事務局開始日: secretariat_start_date ? formatDateCommon(secretariat_start_date, 'everyDay') : '《事務局開始日》',
        事務局開始時間: secretariat_start_date ? formatDateCommon(secretariat_start_date, 'YYYMMDDHHmm') : '《事務局開始時間》',
        事務局終了日: secretariat_end_date ? formatDateCommon(secretariat_end_date, 'everyDay') : '《事務局終了日》',
        事務局終了時間: secretariat_end_date ? formatDateCommon(secretariat_end_date, 'YYYMMDDHHmm') : '《事務局終了時間》',
        レシート有効期限開始: receipt_expiration_start_date
            ? formatDateCommon(receipt_expiration_start_date, 'everyDay')
            : '《レシート有効期限開始》',
        レシート有効期限終了: receipt_expiration_end_date ? formatDateCommon(receipt_expiration_end_date, 'everyDay') : '《レシート有効期限終了》',
        キャンペーンURL: campaign_url ? `<a href="${campaign_url}" target="_blank">${campaign_url}</a>` : '《キャンペーンURL》',
        生成日: '《生成日》',
        主催者名: '《主催者名》',
        '《クライアント名》/《主催者名》': client_name || '《クライアント名》/《主催者名》'
    };
    return prizeReplacements;
}

function handleTranferShortCodeFaq(data, contextData) {
    const shortCodeMap = {
        キャンペーン名: contextData?.name,
        キャンペーン開始: contextData?.campaign_start_date
            ? moment(contextData.campaign_start_date).locale('ja').format('YYYY年MM月DD日（ddd）')
            : null,
        キャンペーン事務局TEL: contextData?.tel,
        キャンペーン事務局Mailアドレス: contextData?.email,
        年末年始休み:
            contextData?.year_end_schedule_from || contextData?.year_end_schedule_to
                ? `(${moment(contextData.year_end_schedule_from).locale('ja').format('YYYY年MM月DD日（ddd）')} ~ ${moment(
                      contextData.year_end_schedule_to
                  )
                      .locale('ja')
                      .format('YYYY年MM月DD日（ddd）')})`
                : null,
        ...cloneMapShortCodeFaq(contextData),
        事務局開始: contextData?.secretariat_start_date ? formatDateCommon(contextData?.secretariat_start_date, 'everyDay') : '《事務局開始》',
        事務局終了: contextData?.secretariat_end_date ? formatDateCommon(contextData?.secretariat_end_date, 'everyDay') : '《事務局終了》',
        事務局電話番号: contextData?.tel ? contextData.tel : '《事務局電話番号》',
        TEL_事務局電話番号: contextData?.is_tel ? (contextData?.tel_check ? contextData.tel_check : '《TEL_事務局電話番号》') : ''
    };
    const result = JSON.parse(JSON.stringify(data));
    for (const [key, items] of Object.entries(result)) {
        items.forEach((text, index) => {
            let replacedText = text;
            Object.entries(shortCodeMap).forEach(([shortCode, value]) => {
                if (value !== null && value !== undefined) {
                    const regex = new RegExp(`《${shortCode}》`, 'g');
                    replacedText = replacedText.replace(regex, value);
                }
            });
            result[key][index] = replacedText;
        });
    }
    return result;
}

function cloneMapShortCodeFaq(dataContext) {
    let shortCodePreview = handleTranferShortCodePreview({ data: { context_data: dataContext } });
    shortCodePreview = {
        ...shortCodePreview,
        キャンペーンURL: dataContext?.campaign_url ? dataContext?.campaign_url : '《キャンペーンURL》',
        '共通：応募条件①': dataContext?.condition1_values ? formatObjectCommon(dataContext?.condition1_values, '\n') : '《共通：応募条件①》',
        '共通：応募条件②': dataContext?.condition2_values ? formatObjectCommon(dataContext?.condition2_values, '\n') : '《共通：応募条件②》',
        'WEB：応募方法': mapDataPlatformPrv('WEB', dataContext?.application_methods, 'keyAndValue', '\n') ?? '《WEB：応募方法》',
        'ハガキ：応募方法': mapDataPlatformPrv('ハガキ', dataContext?.application_methods, 'keyAndValue', '\n') ?? '《ハガキ：応募方法》',
        'X：応募方法': mapDataPlatformPrv('X', dataContext?.application_methods, 'keyAndValue', '\n') ?? '《X：応募方法》',
        'Instagram：応募方法': mapDataPlatformPrv('Instagram', dataContext?.application_methods, 'keyAndValue', '\n') ?? '《Instagram：応募方法》',
        'LINE：応募方法': mapDataPlatformPrv('LINE', dataContext?.application_methods, 'keyAndValue', '\n') ?? '《LINE：応募方法》',
        'TikTok：応募方法': mapDataPlatformPrv('TikTok', dataContext?.application_methods, 'keyAndValue', '\n') ?? '《TikTok：応募方法》',
        '店頭：応募方法': mapDataPlatformPrv('店頭', dataContext?.application_methods, 'keyAndValue', '\n') ?? '《店頭：応募方法》',
        'アプリ：応募方法': mapDataPlatformPrv('アプリ', dataContext?.application_methods, 'keyAndValue', '\n') ?? '《アプリ：応募方法》',
        '共通：応募方法': dataContext?.application_methods ? formatObjectCommon(dataContext?.application_methods, '\n') : '《共通：応募方法》',
        '共通：公式アカウント名＆ID': dataContext?.platform_name_ids
            ? formatObjectCommon(dataContext?.platform_name_ids, '\n')
            : '《共通：公式アカウント名＆ID》',
        '共通：ハッシュタグ': dataContext?.hashtags ? formatObjectCommon(dataContext?.hashtags, '\n') : '《共通：ハッシュタグ》',
        購買条件: dataContext?.purchase_conditions ? Object.keys(dataContext?.purchase_conditions).join('\n') : '《購買条件》',
        購買条件と金額詳細: dataContext?.purchase_conditions ? formatObjectCommon(dataContext?.purchase_conditions, '\n') : '《購買条件と金額詳細》',
        対象商品カテゴリ1: dataContext?.target_product_default
            ? Object.keys(dataContext?.target_product_default).join('\n')
            : '《対象商品カテゴリ1》',
        対象商品カテゴリ2: dataContext?.target_product_default
            ? formatObjectCommon(dataContext?.target_product_default, '\n')
            : '《対象商品カテゴリ2》',
        商品関連自由入力: dataContext?.target_product_child ? formatObjectCommon(dataContext?.target_product_child, '\n') : '《商品関連自由入力》',
        '共通：対象商品カテゴリ': dataContext?.target_product_all
            ? formatObjectCommon(dataContext?.target_product_all, '\n')
            : '《共通：対象商品カテゴリ》',
        IPコンテンツ: dataContext?.information_ip ? Object.keys(dataContext?.information_ip).join('\n') : '《IPコンテンツ》',
        IPコンテンツ詳細含む: dataContext?.information_ip ? formatObjectCommon(dataContext?.information_ip, '\n') : '《IPコンテンツ詳細含む》',
        キャンペーン主催情報詳細含む: convertBrToN(dataContext?.sponsor_information_tie_up) ?? '《キャンペーン主催情報詳細含む》',
        タイアップ流通数報詳細含む:
            dataContext?.sponsor_information_detail?.circulation_number && dataContext?.sponsor_information_detail?.circulation_distribution
                ? `${convertBrToN(dataContext?.sponsor_information_detail?.circulation_number) ?? ''} \n 流通詳細：${convertBrToN(dataContext?.sponsor_information_detail?.circulation_distribution) ?? ''}`
                : '《タイアップ流通数報詳細含む》',
        タイアップメーカー数報詳細含む:
            dataContext?.sponsor_information_detail?.up_manufacturers && dataContext?.sponsor_information_detail?.up_manufacturers_name
                ? `${convertBrToN(dataContext?.sponsor_information_detail?.up_manufacturers) ?? ''} \n メーカー詳細：${convertBrToN(dataContext?.sponsor_information_detail?.up_manufacturers_name) ?? ''}`
                : '《タイアップメーカー数報詳細含む》',
        '抽選(当選人数)': dataContext?.total_number_of_win_prize || '《抽選(当選人数)》',
        お問い合わせ事務局署名: mapSourceContact(dataContext?.contact, dataContext, '\n') ?? '《お問い合わせ事務局署名》',
        '受注範囲大項目+中項目': formatObjecOrderScope(dataContext?.order_scope_medium, '・', '\n') ?? '《受注範囲大項目+中項目》',
        '受注範囲大項目+中項目+詳細': formatObjecOrderScope(dataContext?.order_scope_detail, '\n', '\n') ?? '《受注範囲大項目+中項目+詳細》',
        受注範囲大項目: dataContext?.order_scope_large ? Object.keys(dataContext?.order_scope_large).join('\n') : '《受注範囲大項目》',
        '受注範囲-資料系': mapDataPlatformPartnerAndToolPrv('資料系', dataContext?.order_scope_large, 'keyAndValue', '\n') ?? '《受注範囲-資料系》',
        '受注範囲-お問い合わせ+詳細':
            formatObjecKeyOrderScope('お問い合わせ', dataContext?.order_scope_detail, '\n') ?? '《受注範囲-お問い合わせ+詳細》',
        '受注範囲-応募収集':
            mapDataPlatformPartnerAndToolPrv('応募収集', dataContext?.order_scope_large, 'keyAndValue', '\n') ?? '《受注範囲-応募収集》',
        '受注範囲-事務局関連':
            mapDataPlatformPartnerAndToolPrv('事務局関連', dataContext?.order_scope_large, 'keyAndValue', '\n') ?? '《受注範囲-事務局関連》',
        '受注範囲-事務局関連+詳細': formatObjecKeyOrderScope('事務局関連', dataContext?.order_scope_detail, '\n') ?? '《受注範囲-事務局関連+詳細》',
        '受注範囲-発送': mapDataPlatformPartnerAndToolPrv('発送', dataContext?.order_scope_large, 'keyAndValue', '\n') ?? '《受注範囲-発送》',
        '受注範囲-発送+詳細': formatObjecKeyOrderScope('発送', dataContext?.order_scope_detail, '\n') ?? '《受注範囲-発送+詳細》',
        '受注範囲-制作関連':
            mapDataPlatformPartnerAndToolPrv('制作関連', dataContext?.order_scope_large, 'keyAndValue', '\n') ?? '《受注範囲-制作関連》',
        '受注範囲-制作関連+詳細': formatObjecKeyOrderScope('制作関連', dataContext?.order_scope_detail, '\n') ?? '《受注範囲-制作関連+詳細》',
        '受注範囲-SNSアカウント関連':
            mapDataPlatformPartnerAndToolPrv('SNSアカウント関連', dataContext?.order_scope_large, 'keyAndValue', '\n') ??
            '《受注範囲-SNSアカウント関連》',
        '受注範囲-SNSアカウント関連+詳細':
            formatObjecKeyOrderScope('SNSアカウント関連', dataContext?.order_scope_detail, '\n') ?? '《受注範囲-SNSアカウント関連+詳細》',
        パートナー一覧:
            dataContext?.order_scope_partner_all && dataContext?.order_scope_partner_all?.length > 0
                ? dataContext?.order_scope_partner_all?.join('\n')
                : '《パートナー一覧》',
        'パートナー：受注範囲-お問い合わせ':
            mapDataPlatformPartnerAndToolPrv('お問い合わせ', dataContext?.order_scope_partner, 'keyAndValue', '\n') ??
            '《パートナー：受注範囲-お問い合わせ》',
        'パートナー：受注範囲-応募収集':
            mapDataPlatformPartnerAndToolPrv('応募収集', dataContext?.order_scope_partner, 'keyAndValue', '\n') ??
            '《パートナー：受注範囲-応募収集》',
        'パートナー：受注範囲-事務局関連':
            mapDataPlatformPartnerAndToolPrv('事務局関連', dataContext?.order_scope_partner, 'keyAndValue', '\n') ??
            '《パートナー：受注範囲-事務局関連》',
        'パートナー：受注範囲-発送':
            mapDataPlatformPartnerAndToolPrv('発送', dataContext?.order_scope_partner, 'keyAndValue', '\n') ?? '《パートナー：受注範囲-発送》',
        ツール一覧:
            dataContext?.order_scope_tool_all && dataContext?.order_scope_tool_all?.length > 0
                ? onHandleListUnique(dataContext?.order_scope_tool_all)?.join('\n')
                : '《ツール一覧》',
        'ツール：受注範囲-応募収集':
            mapDataPlatformPartnerAndToolPrv('応募収集', dataContext?.order_scope_tool, 'keyAndValue', '\n') ?? '《ツール：受注範囲-応募収集》',
        'ツール：受注範囲-事務局関連':
            mapDataPlatformPartnerAndToolPrv('事務局関連', dataContext?.order_scope_tool, 'keyAndValue', '\n') ?? '《ツール：受注範囲-事務局関連》',
        '主催者(流通)名': dataContext?.manufacturer_clients?.length > 0 ? dataContext?.manufacturer_clients.join('\n') : '《主催者(流通)名》',
        '共通：応募数': dataContext?.number_of_applications ? formatObjectCommon(dataContext?.number_of_applications, '\n') : '《共通：応募数》',
        '共通：お問い合わせ数': dataContext?.number_of_inquiry_with_total
            ? formatObjectCommon(dataContext?.number_of_inquiry_with_total, '\n')
            : '《共通：お問い合わせ数》',

        '共通：SNSアカウントの友だち・フォロー数': dataContext?.platform_followers_number
            ? formatObjectCommon(dataContext?.platform_followers_number, '\n')
            : '《共通：SNSアカウントの友だち・フォロー数》',
        '広告関連+媒体＆費用': formatObjectEntries(dataContext?.social_platforms, '\n') ?? '《広告関連+媒体＆費用》',
        賞品タイトル賞品名: dataContext?.event_prize_title_name
            ? formatObjectEntries(dataContext?.event_prize_title_name, '\n')
            : '《賞品タイトル賞品名》',
        賞品タイトル当選者人数: dataContext?.event_prize_title_number_win_prize
            ? Object.keys(dataContext?.event_prize_title_number_win_prize).join('\n')
            : '《賞品タイトル当選者人数》',
        '賞品タイトル-賞品名': onHandleFormatEventPrize(dataContext?.event_prizes, '\n') ?? '《賞品タイトル-賞品名》',
        賞品タイトル賞品名当選者人数: dataContext?.event_prize_title_number_win_prize
            ? formatObjectEntries(dataContext?.event_prize_title_number_win_prize, '\n')
            : '《賞品タイトル賞品名当選者人数》',
        賞品タイトル当選者人数抽選人数: dataContext?.event_prize_title_number_win_draw
            ? Object.keys(dataContext?.event_prize_title_number_win_draw).join('\n')
            : '《賞品タイトル当選者人数抽選人数》',
        賞品種類: dataContext?.event_prize_title_number_win_type
            ? formatObjectEntries(dataContext?.event_prize_title_number_win_type, '\n')
            : '《賞品種類》',
        賞品の表示:
            !dataContext?.prize_display || dataContext?.prize_display?.length <= 0
                ? '《賞品の表示》'
                : dataContext?.prize_display
                      .map((item) => {
                          if (item?.is_copy_title_prize) return item?.prize_title;
                          else return `${item?.prize_title}: ${item?.prize_name?.join('、')}`;
                      })
                      .join('\n'),
        'タイトル・賞品':
            !dataContext?.prize_display || dataContext?.prize_display?.length <= 0
                ? '《タイトル・賞品》'
                : dataContext?.prize_display
                      .map((item) => {
                          if (item?.is_copy_title_prize) return item?.prize_title;
                          else return `${item?.prize_title}\n ${item?.prize_name?.join('、')}`;
                      })
                      .join('\n'),
        はがき回収のパートナー住所: convertBrToN(dataContext?.partner_address) ?? '《はがき回収のパートナー住所》',
        お問い合わせDM対応アカウント: dataContext?.contact_information_name_ids
            ? formatObjectCommon(dataContext?.contact_information_name_ids, '\n')
            : '《お問い合わせDM対応アカウント》',
        '受注範囲-お問い合わせ':
            mapDataPlatformPartnerAndToolPrv('お問い合わせ', dataContext?.order_scope_large, 'keyAndValue', '\n') ?? '《受注範囲-お問い合わせ》',
        '受注範囲-応募収集+詳細': formatObjecKeyOrderScope('応募収集', dataContext?.order_scope_detail, '\n') ?? '《受注範囲-応募収集+詳細》'
    };
    return shortCodePreview;
}

export {
    configs,
    DayOfWeek,
    cycleFMT,
    REPORT_DATE,
    findDeliveryCycle,
    replaceQ,
    replaceA,
    funcConditionLabel,
    handleDataAllRule,
    initFileDocs,
    handMapDataDocument2,
    onHandleMapCheckSchedule,
    mapDataPlatformPrv,
    handleTranferShortCodePreview,
    handleTranferShortCodeFaq
};
